/**
 * Student Planner API — the session student's Planner feed.
 *
 * GET /v1/student-planner/feed[?until=]
 *
 * Self only: a student reads their own work at the active school. The first
 * page (no `until`) holds every unfinished or missing-flagged item since the
 * start of the school year, everything due from 30 days ago through 60 days
 * ahead, and undated work. Later work comes one 60-day page at a time: pass the
 * previous response's `nextUntil` as `until` to get the items due in the 60
 * days before it.
 */

import { z } from 'zod'

import { PlannerItemSchema } from '../../schemas/entities/planner-item'

export const GetPlannerFeedQuerySchema = z.object({
  /** Exclusive upper edge of a later page (UTC ISO), from a previous `nextUntil`. */
  until: z.string().datetime().optional()
})
export type GetPlannerFeedQuery = z.infer<typeof GetPlannerFeedQuerySchema>

export const GetPlannerFeedResponseSchema = z.object({
  /** School IANA timezone that day logic uses; null when the school has none on file. */
  timezone: z.string().nullable(),
  /** Ordered by effective due instant, undated items last. */
  items: z.array(PlannerItemSchema),
  /** Pass as `until` to fetch the next page; null when nothing is due later. */
  nextUntil: z.string().datetime().nullable()
})
export type GetPlannerFeedResponse = z.infer<typeof GetPlannerFeedResponseSchema>
